import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Pre } from '@/features/portal/pre'

/**
 * Pedido de horário de quem ainda não é atendido. Rota pública, sem sessão e
 * sem nada que diga que atendimento é este. `?t=` é o slug da terapeuta dona
 * da agenda: é ele que vem no link que ela manda.
 */
const preSearch = z.object({
  t: z
    .string()
    .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/)
    .max(60)
    .optional()
    .catch(undefined),
})

export const Route = createFileRoute('/portal/pre')({
  validateSearch: preSearch,
  component: function PrePublico() {
    const { t } = Route.useSearch()
    return <Pre slug={t ?? null} />
  },
})
